<template>
  <div class="CompactEventBlock block" :class="{ 'CompactEventBlock--active': isOnline }">
    <div v-if="!isOnline" class="CompactEventBlock__time">
      {{ timeString }}
    </div>
    <div v-else class="CompactEventBlock__time">
      <img class="CompactEventBlock__right-now-icon" src="@/assets/icons/right-now.svg" alt="" />
      {{ $t('rightNow') }}
    </div>
    <div class="CompactEventBlock__title">{{ $localized(event.localized_name, event.name) }}</div>
    <div class="CompactEventBlock__button" v-if="isOnline" @click="$emit('watch-zoom', event)">
      <img src="@/assets/icons/arrow-r-dark.svg" alt="" />
    </div>
    <div class="CompactEventBlock__button" v-if="event.video_link && !isOnline" @click="$emit('watch-video', event)">
      <img src="@/assets/icons/play.svg" alt="play" />
    </div>
  </div>
</template>

<script>
/*event:Object
course:null
experts:Array[0]
id:114
internal_link:"http://imeeting.huawei.com/meeting/joinzoom?id=0135839056&app=welink"
name:"Questions and discussion regarding Report №2"
time_finish:1639470000000
time_start:1639469700000
type:Object
user:Object
zoom_link:"https://facecast.net/w/or6p5u"
*/
import moment from 'moment'
import _inRange from "lodash/_baseInRange";

export default {
  name: 'CompactEventBlock',
  props: {
    event: Object,
    active: Boolean,
  },
  computed: {
    isOnline() {
      const {time_start, time_finish} = this.event
      return _inRange(moment(), time_start, time_finish)
    },
    timeString() {
      const format = (date) => moment(date).format('HH:MM')
      return `${format(this.event.time_start)} · ${format(this.event.time_finish)}`
    },
  },
}
</script>

<style lang="scss">
.CompactEventBlock {
  width: 112px;
  padding: 15px 17px;
  flex-shrink: 0;

  background: #ffffff;
  border: 1px solid #f2f2f2;
  border-radius: 13px;

  & + & {
    margin-left: 10px;
  }

  &__right-now-icon {
    margin-right: 6px;
  }

  &--active {
    background: #003882;
    color: #ffffff;

    .CompactEventBlock__button {
      background: white;
    }
  }

  &__time {
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    margin-bottom: 9px;
  }

  &__title {
    height: 42px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

    font-weight: 700;
    font-size: 12px;
    line-height: 117.5%;
    margin-bottom: 16px;
  }

  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    background: rgba(204, 215, 230, 0.3);
    border-radius: 5px;
  }
}
</style>
